import BaseService from "../CorBase/BaseService";
import BaseFilter from '../CorBase/BaseFilter';

export class DiscountService extends BaseService {
	constructor() {
		super('/Discount');
	}


	public getAllByFilter(filter: DiscountFilter) {
		return super.getAllByFilterBase(filter);
	}
}

export class DiscountFilter extends BaseFilter {
	constructor(idTenant?: string | null) {
		super();

		this._idTenant = idTenant;
	}

	private _idTenant?: string | null;

	public getAllParams(): {} {
		let data = Object.assign({},
			(this._idTenant != null ? { IdTenant: this._idTenant } : {})

		);

		return data;
	};
}